<div class="dialog__header">
  <div class="dialog__header-title-wrapper">
    <h2 class="dialog__header-title" [ngStyle]="{ 'font-size': titleFontSize }">
      {{ getTitle() }}
    </h2>
  </div>
  <button
    mat-icon-button
    mat-dialog-close
    type="reset"
    aria-label="Close dialog"
    (click)="onCancel()"
  >
    <firebird-web-icon
      class="close-icon"
      name="cross"
      width="19px"
      height="19px"
    ></firebird-web-icon>
  </button>
</div>
<mat-divider></mat-divider>
<div class="dialog__content">
  <ng-content></ng-content>
</div>
@if (showButtons) {
<div class="dialog__footer">
  @if (showConfirmButton) {
  <button
    class="dialog__button dialog__button--cancel"
    mat-flat-button
    mat-dialog-close
    (click)="onCancel()"
  >
    {{ cancelText }}
  </button>
  <button
    class="dialog__button dialog__button--confirm"
    mat-button
    color="primary"
    (click)="onConfirm()"
  >
    {{ confirmText }}
  </button>
  } @if (!showConfirmButton) {
  <button
    class="dialog__button dialog__button--confirm"
    mat-button
    color="primary"
    mat-dialog-close
  >
    {{ cancelText }}
  </button>
  }
</div>
}
